<div class="container">
  @if (isAuthenticated()) {
    <div class="col-xs-12 col-sm-12 col-md-12 pt-3">
      <br>
      <div class="row justify-content-between">
        <div class="col-xs-6">
          <h2>Users Portal Access - User Activity</h2>
        </div>
      </div>
      <br>
      <br>
      <div class="row justify-content-between">
        <div class="col-xs-6 col-9">
          <div class="dropdown col" dropdown>
            <h2 class="row">
              <div class="col-auto">
                @if (this.uS.cIndex>=0) {
                  {{ this.dDDS.dropdown.internalContactList[this.uS.cIndex].firstname }} {{ this.dDDS.dropdown.internalContactList[this.uS.cIndex].lastname }} [{{ this.dDDS.dropdown.internalContactList[this.uS.cIndex].companyname }}]
                }
                @else {
                  All Users
                }  
              </div> 
              <mat-form-field class="col member">
                <mat-select [(ngModel)]="this.uS.cIndex">
                  <mat-option (click)="this.uS.onSelected('0',-1)" value="-1">All Users</mat-option>
                  @for (contact of this.dDDS.dropdown.internalContactList; track contact; let cIndex = $index) {
                    <mat-option (click)="this.uS.onSelected(contact.idcontact,cIndex)" value="cIndex">{{ contact.firstname }} {{ contact.lastname }} [{{ contact.companyname }}]</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </h2>
          </div>
        </div>
        <div class="col-auto">
          <button class="btn btn-info" (click)="csv('activity')">CSV</button>
        </div>
      </div>
      <br>
      <div class="form-container" autocomplete="off">
        <mat-form-field>
          <input matInput placeholder="Search text" maxlength="45" autocomplete="random-search-text" id="search-text" [(ngModel)]="this.uS.searchtext" (keyup)="this.uS.filterTable()">
        </mat-form-field>
      </div>
      <div class="tablebox">
        <table class="table col" id="activity" maxHeight="500" bordered="true">
          <tbody>
            <tr class="tableseperator"><td></td><td></td><td></td><td></td><td></td></tr>
            <tr>
              <th>Table</th>
              <th>User</th>
              <th>Date</th>
              <th>Created Records</th>
              <th>Modified Records</th>
            </tr>
            <tr class="tableseperator"><td></td><td></td><td></td><td></td><td></td></tr>
            @if (this.uS.filteredData!==undefined) {
              @for (tables of this.uS.filteredData['categories']; track tables; let ActivityIndex = $index) {
                @if (this.uS.filteredData[tables['category']].length>0) {
                  <tr class="tableseperator"><td></td><td></td><td></td><td></td><td></td></tr>
                  <tr>
                    <td>{{ tables['category'] | titlecase }}</td>
                    <td>{{ this.uS.filteredData[tables['category']][0].name }}</td>
                    <td>{{ this.uS.filteredData[tables['category']][0].datemod | date:'EEE, MMM d, y' }}</td>
                    <td>{{ this.uS.filteredData[tables['category']][0].count }}</td>
                    <td>{{ this.uS.filteredData[tables['category']][0].countmod }}</td>
                  </tr>
                  @for (table of this.uS.filteredData[tables['category']]; track table; let rowIndex = $index) {
                    @if (rowIndex>0) {
                      <tr>
                        <td></td>
                        <td>{{ table.name }}</td>
                        <td>{{ table.datemod | date:'EEE, MMM d, y' }}</td>
                        <td>{{ table.count }}</td>
                        <td>{{ table.countmod }}</td>
                      </tr>
                    }
                  }
                }
              }
            }
            <tr class="tableseperator"><td></td><td></td><td></td><td></td><td></td></tr>
          </tbody>
        </table>
      </div>
      <br><br>
    </div>
  }

  @if (!isAuthenticated()) {
    <div class="col-xs-12 col-sm-10 col-md-7 col-sm-offset-1 col-md-offset-2 pt-3">
      <app-teamlogin></app-teamlogin>
    </div>
  }
</div>